<template>  
  <div class="main readWatchlist">
    <!--抄表数据展示-->
    <div class="eMeterTable">
      <el-table
        :data="eMeterData"
        style="width: 100%">
        <el-table-column
          prop="space_name"
          label="电表位置">
        </el-table-column>
        <el-table-column
          prop="device_name"
          label="电表名称">
        </el-table-column>
        <el-table-column
          prop="device_no_id"
          label="电表编号">
        </el-table-column>
        <el-table-column
          prop="datetime"
          label="抄表时间">
        </el-table-column>
        <el-table-column
          prop="max_read_num"
          label="电表读数(KWH)">
        </el-table-column>
        <el-table-column
          prop="daynum"
          label="用电量(KWH)">
        </el-table-column>
      </el-table>
    </div>
    <!--翻页组件-->
    <div class="choosePage" v-if="total > perPage">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="currentPage"
        :page-size="perPage"
        :total="total"
        @current-change="changePage">
      </el-pagination>
    </div>

  </div>
</template>

<script>
  import * as date from "../../../../../static/js/date.js";

  import { deviceApi } from "../../../../../static/js/api.js"
  import { showToast } from "../../../../../static/js/utility/utility.js"
  export default {
    name: 'ReadWatchTitle',
    data() {
      return {
        'buildingID':'001',
        'total':100,  //真实页面数*10
        'perPage':10,
        'currentPage':1,
        'dateRange':[],
        'eMeterData': [],
      }
    },
    mounted: async function() {
      // 初始化时间范围
      this.initDateRange();
      // let buildingEMeterInfo = await powerControl.getBuildingEMeterValue(this.buildingID, this.dateRange[0], this.dateRange[1],this.currentPage, this.perPage);
      // buildingEMeterInfo = buildingEMeterInfo.body;
      // this.eMeterData = buildingEMeterInfo;
      this.getEmeterByDayList()
    },
    created: async function() {
    },
    methods: {
      //获取电表读数列表
      async getEmeterByDayList(){
        let that = this;
        const dataObj = {
          'page':that.currentPage,
          'perPage':that.perPage,
          'startTime':this.dateRange[0],
          'endTime':this.dateRange[1],
        }
        const res = await deviceApi.getEmeterByDayList(dataObj)
        if(res.meta.code == '200'){
          that.eMeterData = res.data.list
          that.total = parseInt(res.data.total)
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
      // 页面改变
      async changePage(data) {
        // console.log('当前页面：',data);
        this.currentPage = '' + data;
        // let buildingEMeterInfo = await powerControl.getBuildingEMeterValue(this.buildingID, this.dateRange[0], this.dateRange[1],this.currentPage, this.perPage);
        // buildingEMeterInfo = buildingEMeterInfo.body;
        // this.eMeterData = buildingEMeterInfo;
        this.getEmeterByDayList()
      },
      // 初始化日期选择范围
      initDateRange() {
        this.dateRange[0] = date.getLastMonthDate();
        this.dateRange[1] = date.getNowFormatDate();
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingWatchDateRange":async function(newVal, oldVal) {
        this.dateRange = newVal;
        // let buildingEMeterInfo = await powerControl.getBuildingEMeterValue(this.buildingID, this.dateRange[0], this.dateRange[1],this.currentPage, this.perPage);
        // buildingEMeterInfo = buildingEMeterInfo.body;
        // this.eMeterData = buildingEMeterInfo;
        this.getEmeterByDayList()
      },
      "$store.state.buildingWatchPerPage":async function(newVal, oldVal) {
        this.perPage = newVal;
        // let buildingEMeterInfo = await powerControl.getBuildingEMeterValue(this.buildingID, this.dateRange[0], this.dateRange[1],this.currentPage, this.perPage);
        // buildingEMeterInfo = buildingEMeterInfo.body;
        // this.eMeterData = buildingEMeterInfo;
        this.getEmeterByDayList()
      },

    },
    props: []
  }
</script>

<style lang="scss">
.readWatchlist{
  .el-table th{
    background-color: #e4e8f9 !important;
    color: #333;
  }
  .main {
    width:100%;
    height: 100%;
  }
  .choosePage {
    margin-top: 20px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CEnergyManage/BuildingInfo/ReadWatchList.vue